import { Box, Button, CircularProgress, Grid, TextField } from "@mui/material";
import Header from "components/Header";
import { BasePathProvider, useBasePath } from "components/Providers"
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { saveSelf as approvalPatch, removeItem } from 'store/leave/punch-request';
import * as snackbar from '../../../../utils/snackbar'

export default function PunchApprovalForm({ record }) {
    const basePath = useBasePath();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();


    const { control, handleSubmit, formState, } = useForm({
        defaultValues: {
            ...record
        }
    })

    const onSubmit = async (data) => {
        const payload = {
            id: record.id,
            status: 'denied',
            approvalNote: data.approvalNote
        }
        try {
            await dispatch(approvalPatch(payload)).unwrap()
            snackbar.success('Successfully Denied')
            dispatch(removeItem(record?.id))
        } catch (error) {
            snackbar.error('Error Saving! Please try again later')
        }
        navigate(basePath)
    }

    return (
        <BasePathProvider value={`${basePath}/punch-approvals`}>
            <Header title={t('Punch Approval')} small close borderBottom />
            <Box data-component="PunchApprovalForm" component="form" onSubmit={(handleSubmit(onSubmit))} py={2} px={1}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Controller
                            name="approvalNote"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="Denial Reason"
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    error={!!formState.errors.approvalNote}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Box textAlign={'right'} mt={3}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                type="submit"
                                disabled={formState.isSubmitting || !formState.isDirty}
                                startIcon={formState.isSubmitting && <CircularProgress size={20} />}
                            >
                                {formState.isSubmitting ? 'Saving...' : 'Save'}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </BasePathProvider>
    )
}
